import { ResolveFn } from '@angular/router';
import { Observable, tap, of, map } from 'rxjs';
import { inject } from '@angular/core';
import { OrganizationSourceData, OrganizationSourceDataService } from 'riterz-core';

export const organizationSourceDataResolver: ResolveFn<Observable<OrganizationSourceData[]|null>> = (
  route, 
  state,
  organizationSourceDataService: OrganizationSourceDataService = inject(OrganizationSourceDataService),
) => {
  // Fall back to the parent route: with the default `emptyOnly` params
  // inheritance strategy, a non-empty child path doesn't inherit :organizationId.
  const organizationId = route.paramMap.get('organizationId')
    ?? route.parent?.paramMap.get('organizationId');

  if (!organizationId) {
    return of(null);
  }

  return organizationSourceDataService
    .getPublicOrganizationData(organizationId)
    .pipe(
      map(response => response.data),
      tap({
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: () => {}
      })
    );
    
};
